import React, { useContext, useMemo, useState } from 'react';
import { useNavigate } from 'react-router';
import { BarcodeExportConfigurationContext } from '../../../../context/BarcodeExportConfigurationContext';
import { Routing } from '../../../../util/routes.util';
import { CreateButton } from '../../../components/Button';
import Table from '../../../components/Table';
import { Searchbar } from '../../../components/TextInput';

export default function BarcodeSettingsScreen() {
  const navigate = useNavigate();

  const { barcodeExportConfigurations } = useContext(BarcodeExportConfigurationContext);

  const allItems = useMemo(() => {
    return [...barcodeExportConfigurations.values()];
  }, [barcodeExportConfigurations]);
  const [items, setItems] = useState([...allItems]);

  const [query, setQuery] = useState('');

  return (
    <div className='content-x content-y-screen flex h-full flex-grow flex-col gap-4'>
      <div className='grid gap-2'>
        <p className='page-title'>Barcode Settings</p>
        <p className='subtitle'>Create configurations for your barcode printing needs!</p>
      </div>

      <div className='flex flex-grow flex-col gap-2'>
        <div className='flex justify-between gap-2'>
          <Searchbar value={query} onChange={value => setQuery(value)} />
          <div>
            <CreateButton onClick={() => navigate(Routing.settings.barcodes.create())} />
          </div>
        </div>
        <Table
          items={items}
          onClick={item => navigate(Routing.settings.barcodes.update(item.id))}
          headers={[
            { key: 'name', name: 'Name', text: item => item.name },
            {
              key: 'entity_type',
              name: 'Entity Type',
              text: item => item.entityType,
            },
            { key: 'formats', name: 'Formats', text: item => item.entries.length.toString() },
          ]}
        />
      </div>
    </div>
  );
}
